import { createContext, useContext, useMemo, useState } from 'react';
import client from '../api/client';
const AuthContext=createContext(null);
function storedUser(){ try{return JSON.parse(localStorage.getItem('uniloot_user'))||null;}catch{return null;} }
export function AuthProvider({children}){
  const [user,setUser]=useState(storedUser);
  const save=(data)=>{ localStorage.setItem('uniloot_token',data.token); localStorage.setItem('uniloot_user',JSON.stringify(data.user)); setUser(data.user); return data.user; };
  const login=async(payload)=>save((await client.post('/auth/login',payload)).data);
  const register=async(payload)=>save((await client.post('/auth/register',payload)).data);
  const logout=()=>{ localStorage.removeItem('uniloot_token'); localStorage.removeItem('uniloot_user'); setUser(null); };
  const value=useMemo(()=>({user,login,register,logout,isAuthenticated:Boolean(user)}),[user]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export function useAuth(){ const value=useContext(AuthContext); if(!value) throw new Error('useAuth harus berada di AuthProvider'); return value; }
